import {
  CollideEvent,
  CollideId,
  isPowerCollider,
  TapCollider,
} from '../../defs/collide';
import {
  despawnBlockEntity,
  type ShieldBubbleBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BreakEffect } from '../effects/BreakEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

export class ShieldBubbleCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: ShieldBubbleBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: ShieldBubbleBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap(event: CollideEvent) {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveAttack(event: CollideEvent) {
    const collider = event.collider;

    // Only attack if is a power collision (from power blocks or boosters)
    if (isPowerCollider(collider?.type)) {
      await this.attack();
      return true;
    }

    return false;
  }

  private async attack() {
    const position = this.entity.c.position.mapPosition;
    despawnBlockEntity(this.scene, this.entity);
    new BreakEffect(this.scene, {
      position,
      size: this.entity.c.block.props,
      color: 0xbbe3ee,
      alpha: 0.3,
    }).execute();
  }
}
